import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartComponent } from './chart.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';

@NgModule({
    declarations: [
        ChartComponent
    ],
    imports: [
        CommonModule,
        NgxEchartsModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule
    ],
    exports: [
        ChartComponent
    ]
})
export class ChartModule { }
